import { Type } from 'class-transformer';

export class ClientState {
  public userId: string;

  public search: {lastUpdated: number};

  public clientCollection: {activeCollectionId?: string};

  @Type(() => Date)
  public introductionDismissedAt?: Date;
}
